// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,

  firebase: {
      apiKey: "AIzaSyDcsb0Ziu85j0BpIbicEmPTffR3H_RGb68",
      authDomain: "intense-fire-8692.firebaseapp.com",
      databaseURL: "https://intense-fire-8692.firebaseio.com",
      projectId: "intense-fire-8692",
      storageBucket: "intense-fire-8692.appspot.com",
      messagingSenderId: "335408827936"
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts